import { uid } from 'radash'
import { memo } from 'react'
import Button from '~components/ui/button'
import { cn } from '~utils/cn'

import { FileUploadButtonProps } from './types'

const FileUploadButton = ({
  accept,
  children,
  disabled,
  className,
  onChange,
}: FileUploadButtonProps) => {
  const id = uid(10)

  return (
    <Button
      disabled={disabled}
      priority="secondary"
      size="small"
      className={cn('relative', className)}
      rounded={false}
    >
      {children}
      <label
        aria-label="hidden-element"
        htmlFor={id}
        aria-disabled={disabled}
        className="absolute inset-0 z-10 cursor-pointer aria-disabled:cursor-default"
      >
        <input
          className="absolute inset-0 opacity-0 cursor-pointer"
          type="file"
          name="file"
          id={id}
          disabled={disabled}
          onChange={onChange}
          accept={accept}
          multiple
        />
      </label>
    </Button>
  )
}

export default memo(FileUploadButton)
